import React from 'react';
import Template from '../../components/Template';
import TableOsDetalhado from '../../components/TableOsDetalhado';
import i18n from '../../translate/i18n';
import './styles.css';

export default function RelatorioDetalhadoOS() {

  return (
    <Template path={i18n.t('menu.analytical report')}>
      <div className="position-relative p-3 ">
        <TableOsDetalhado />
      </div>
    </Template >
  )
}
